export default __webpack_public_path__ + "static/ee970c43-6dcc-47fc-b87f-089c8666389f-6ff82bf38bb806ba4b7f4c1250cecd5b.woff";